import _ from "lodash";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  getAssessmentQuery,
  getUnitPlanDetailsQuery,
  getAssessmentCourseDetailsQuery,
  getAssessmentLearningCourseDetailsQuery,
  getAIPromptsBasicDetailsQuery,
  getAssessmentLinkedAssignmentsQuery,
} from "Assessments/modules/AssessmentQuery";
import {
  updateAssessmentInRedux,
  updateAIDataInRedux,
  deleteAssessment,
  onClose,
  onClickEdit,
  showNotEditableLePlanToast,
  showWorksheetNotEditableToast,
  updateAssessmentInCache,
  clearAssessmentTool,
} from "Assessments/modules/AssessmentModule";
import { updateUnitPlanInRedux } from "IBPlanner/modules/IBPlannerModule";
import { graphql, compose } from "lib/apolloClient";
import withLoader from "UIComponents/GqlWithLoader";
import withPusherSubscribe from "UIComponents/PusherSubscribeHoc";
import I18nHOC from "UIComponents/I18nHOC";
import withPresenceChannel from "UIComponents/PresenceChannelHoc";
import withPusherBind from "UIComponents/PusherConsumerHoc";
import UIModal from "UIComponents/UIModal";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import Loading from "UIComponents/Loading";
import {
  getPlannerFieldsOfNode,
  ResourceDetailsContext,
  isUnitPlanEditPermission,
} from "UnitPlans/modules/UnitPlanModule";
import AddAssignment from "ClassRoom/components/AddAssignment";
import {
  LTI_PLACEMENT,
  LTI_SERVICE_DETAILS,
  getLTIName,
} from "LTIComponent/modules/Utils";
import { generateRnPContextsByLevel } from "Utils/RnPHelpers";

import classes from "./AssessmentDetails.scss";
import {
  setToastMsg,
  getUserInfo,
  setCurrentPageTitle,
  setGlobalTrayEnabledState,
} from "Login/modules/LoginModule";
import { getIsItemLocked, getHasConflict } from "CourseFlow/modules/Utils";
import { getPlannerTemplateFromCache } from "modules/CommonGraphqlHelpers";
import { getPlannerTemplateQuery } from "modules/CommonQuery";

import {
  goToRelativeRoute,
  trackEntityPreview,
  addApiEvent,
  getVariablesForLocalisedPlannerTemplates,
  hideIntercom,
  showIntercom,
} from "modules/Services";
import { getPrintFile } from "modules/PrintThunks";
import {
  ResourceView,
  ResourceEdit,
} from "UnitPlans/components/LibraryCommonComponents";
import ACLStore from "lib/aclStore";
import { withCombinedAccessBlocker } from "lib/PermissionAware";
import { getPlannerElementSetsOfCurriculumEnhancer } from "modules/CommonQueryEnhancers";
import {
  CURRICULUM_TYPE_DP,
  TODDLE_LIBRARY,
  LEARNING_ENGAGEMENT,
  ASSESSMENT,
  ASSESSMENT_TYPE_QUICK_TASK,
  CURRICULUM_TYPE_MYP,
  MYP_IB_DEFINED,
  CURRICULUM_TYPE_UBD,
  TASK_TYPE_WORKSHEET,
  TASK_TYPE_AI_TUTOR,
} from "Constants/stringConstants";
import { withRouter } from "react-router";
import {
  SNPv2_VISITOR_PORTAL_PERM_GROUP,
  CAN_EDIT_COURSE_FLOW_PERMISSION,
  USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
} from "Constants/permissionConstants";
import {
  getUnitDetailsFromUnitPlanField,
  combineUnitPlanMultiFieldData,
  getWorksheetSteps,
  removeAssessmentFromLocalStorage,
  getDynamicTemplate,
} from "Assessments/modules/Utils";
import {
  getSelectedLearningCourseId,
  isBluePrintTeacherCourseSyncEnabled,
} from "LearningCourse/modules/Utils";
import {
  getIsLearningCoursesEnabled,
  getIsCourseBasedGradingEnabled,
} from "LearningCourses/modules/Utils";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";

import { Dialog, Button, DSProvider } from "@toddle-edu/ds-web";
import {
  updateShowPremiumBanner,
  updateViewCountForToddleLibrary,
} from "ToddleLibrary/modules/ToddleLibraryModule";
import { isUnitPage } from "ToddleLibrary/modules/ToddleLibraryUtils";
import { ASSESSMENT_TYPE_WORKSHEET } from "Worksheet/modules/WorksheetConstants";
import { removeFieldsFromTemplate } from "Worksheet/modules/WorksheetUtils";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
  getCurrentCurriculumProgramType,
  getSelectedCourseId,
} from "modules/CommonSelectors";
import { resourceLibrarySourceOrg } from "config";
import { getLTIServicesForCurriculumQuery } from "AppComponents/LTIComponent/modules/LTIQueries";
import { getGradeScalesQueryEnhancer } from "AppComponents/AssessmentGradeScaleTool/modules/AssessmentGradeScaleToolEnhancers";
import {
  getIsEnabledLTITools,
  getIsEnableLTIInSubmissionTemplate,
  getCreateAssignmentModalData,
  getEditAssignmentModalDataBasedOnAssessmentType,
  ASSESSMENT_TYPE_UID_CREATE_OPTION_MAPPING,
} from "ClassRoom/modules/utils";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
const AI_TUTOR_AWARDS_FLAG = "FeatureFlag:AITutorAwards";
const REVIEWER_ELIGIBLE_ORG_ID = "372940110473207511";
import { useI18n } from "Hooks";
import ACLStorage from "lib/aclService";
import withDerivedProps from "lib/withDerivedProps";
import withControlParameters from "lib/aclService/hoc/withControlParameters";
import { getIsLearningCoursesEnabledForUnit } from "UnitPlans/modules/UnitViewModeUtils";
import {
  getCourseGradingConfigQuery,
  getMultiSubjectsGradingConfigQuery,
  getMYPIBDefinedGradeScalesQuery,
} from "GradingSetupV2/modules/GradingSetupV2Queries";
import { getIsConfigurationEnabledForCPAY } from "modules/PermissionModule";
import {
  getGradingConfigTypesFilter,
  checkAssignmentContributionMethodValue,
} from "GradingSetupV2/modules/Utils";
import { WithConfigurationsAndPreferences } from "Utils/ConfigurationUtils/hoc";
import { generateConfigurationQueryVariablesV2 } from "Utils/ConfigurationUtils/Utils";

import { getIsGradingPeriodUnlocked } from "GradingSetup/modules/Utils";

const getAddAssignmentModalData = ({
  t,
  key,
  currentAssessmentTypes, // for edit
  ubdAssessmentTypes, // for create
  mode,
  assessmentDetails,
  isSettingsStepOnly = false,
  grades,
}) => {
  if (isSettingsStepOnly) {
    return {
      contentType: "ASSESSMENT",
      steps: [
        {
          label: t("classRoom:assign_settings"),
          value: "SETTINGS",
          heading: t("classRoom:assign_settings"),
        },
      ],
      grades,
    };
  }
  switch (mode) {
    case "create":
      return {
        ...getCreateAssignmentModalData({
          t,
          key,
          ubdAssessmentTypes,
          currentAssessmentTypes,
        }),
        grades,
      };
    default:
      return {
        ...getEditAssignmentModalDataBasedOnAssessmentType({
          t,
          content: assessmentDetails,
          currentAssessmentTypes,
        }),
        grades,
      };
  }
};

const ACCESS_PERMISSIONS = ["TeacherPortal", SNPv2_VISITOR_PORTAL_PERM_GROUP];
const ACCESS_PERMISSIONS_WITH_FAMILY_ACCESS = [
  "TeacherPortal",
  "FamilyPortal",
  SNPv2_VISITOR_PORTAL_PERM_GROUP,
];
const PLANNER_ELEMENT_TYPES_MAPPING = {
  [CURRICULUM_TYPE_DP]: ["DP_PEDAGOGICAL_APPROACH"],
};
const defaultOption = "CREATE_ASSESSMENT";

/**
 * Extracts grades from Redux state based on whether learning courses are enabled
 */
const getGradesFromState = state => {
  const isLearningCoursesEnabledFlag = getIsLearningCoursesEnabled();
  let gradesData;
  if (isLearningCoursesEnabledFlag) {
    gradesData = _.get(
      state,
      "learningCourse.selectedLearningCourse.grades",
      []
    );
  } else {
    gradesData = _.get(state, "teacher.selected_class.grades", []);
  }
  return gradesData;
};

const getAssessmentType = assessmentType => {
  switch (assessmentType) {
    case "le":
      return "common:le_label";
    case "fmt":
      return "classRoom:formative_assessment";
    case "smt":
      return "classRoom:summative_assessment";
  }
};
const getWarningMsgParams = (assessmentType, t) => ({
  assessmentType: t(getAssessmentType(assessmentType)),
});

const getAssignmentModalData = ({ t, mode }) => {
  return {
    mode: mode,
    creationMode: "ASSIGN_TO_CLASS",
    contentType: "ASSESSMENT",
    updateUnitPlanDataInRedux: false,
    steps: getWorksheetSteps(t),
    createHeader: t("common:worksheet"),
    editHeaderText: t("common:edit_with_label", {
      label: t("common:worksheet"),
    }),
  };
};

class AssessmentDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    props?.setAssessmentDetailsRef?.(this);
    this.state = {
      showDeleteDialogueBox: false,
    };
    this.step = null;
  }

  UNSAFE_componentWillMount = () => {
    const { assessmentDetails, updateUnitPlanDataInRedux = true } = this.props;
    const { isDeleted } = assessmentDetails || {};

    if (isDeleted) {
      this.props.onClose();
      this.props.setToastMsg("toastMsgs:trying_to_access_deleted_le");
    } else {
      this.props.updateAssessmentInRedux({
        templateId: _.get(this.props.assessmentDetails, "templateId", ""),
      });
      if (updateUnitPlanDataInRedux) {
        this.props.updateUnitPlanInRedux({
          unitPlanId: _.get(this.props.assessmentDetails, "unitPlan.id", ""),
          templateId: _.get(
            this.props.assessmentDetails,
            "unitPlan.templateId",
            ""
          ),
        });
      }
    }
  };

  componentDidMount = () => {
    const {
      mode,
      isUnitPlanEditPermission,
      assessmentDetails,
      goToRelativeRoute,
      isCommunity,
      isToddleLibrary,
      showNotEditableLePlanToast,
      showWorksheetNotEditableToast,
      renderAsComponent,
      trackEntityPreview,
      addApiEvent,
      userType,
      setCurrentPageTitle,
      pageTitleInfo,
      updateShowPremiumBanner,
      updateViewCountForToddleLibrary,
      setGlobalTrayEnabledState,
      hideIntercom,
      assignmentId,
      updateAssessmentInRedux,
      getCurrentAssessmentTypes,
      setIsAssessmentFetched,
      organizationId,
    } = this.props;

    if (setIsAssessmentFetched) {
      setIsAssessmentFetched(prev => !prev);
    }

    this.notifyCommentCounts();

    if (userType === "staff" && !isCommunity) {
      /**
       * This API event is for analytics on teachers or staff
       */
      addApiEvent({ eventType: "VIEW_ASSESSMENT", onlyOnceInADay: true });
    }

    setGlobalTrayEnabledState(false); // For Hiding the tray on Component Mounted
    hideIntercom();

    if (isToddleLibrary) {
      updateViewCountForToddleLibrary({
        id: _.get(assessmentDetails, "id", ""),
        type: "ASSESSMENT",
        operation: "VIEW",
      });
    }

    updateShowPremiumBanner(
      _.get(assessmentDetails, "showLibraryPremiumBannerForUser", false)
    );

    // when navigating from planning insights - page title appears blank
    // in that case, set the page title to type of assessment
    if (_.isEmpty(pageTitleInfo?.label)) {
      const assessmentTypeMapping = getCurrentAssessmentTypes();

      setCurrentPageTitle({
        from: "admin",
        label: _.get(
          assessmentTypeMapping[
            _.get(assessmentDetails, "assessmentType.value") ?? "le"
          ],
          "localeLabel"
        ),
      });
    }
    const isWorksheet =
      _.get(assessmentDetails, "taskType.type") === TASK_TYPE_WORKSHEET ||
      _.get(assessmentDetails, "assessmentType.value") === "worksheet";

    // Adding this check for worksheet as renderAsComponent is true for worksheet
    if (isWorksheet && mode != "view" && isCommunity) {
      const isEditPerm = ACLStore.can("FeatureFlag:CanEditWorksheet");

      if (!isEditPerm) {
        goToRelativeRoute({
          route: "./view",
          type: "replace",
          replacePath: mode,
        });
        showWorksheetNotEditableToast();
      }
    }

    if (assignmentId) {
      const assessmentTools = _.get(
        assessmentDetails,
        "assessmentTools.edges",
        []
      );
      updateAssessmentInRedux({
        initialAssessmentToolTypes: _.map(assessmentTools, ({ node }) =>
          _.get(node, "assessmentToolType")
        ),
      });
    }

    if (renderAsComponent) return;

    const isAITutor =
      _.get(assessmentDetails, "assessmentType.value") === "ai_tutor" ||
      _.get(assessmentDetails, "taskType.type") === TASK_TYPE_AI_TUTOR;
    const isReviewerEligibleOrg =
      String(organizationId) === REVIEWER_ELIGIBLE_ORG_ID;
    if (
      mode != "view" &&
      isAITutor &&
      isReviewerEligibleOrg &&
      ACLStore.can(AI_TUTOR_AWARDS_FLAG)
    ) {
      goToRelativeRoute({
        route: "./view",
        type: "replace",
        replacePath: mode,
      });
      return;
    }

    if (mode != "view") {
      const isEditPermission = isCommunity
        ? false
        : isUnitPlanEditPermission({
            unitPlanId: _.get(assessmentDetails, "unitPlan.id", ""),
          }) || ACLStore.can("TeacherPortal:CanEditUnitPlan");
      if (!isEditPermission || !_.includes(["edit", "create"], mode)) {
        goToRelativeRoute({
          route: "./view",
          type: "replace",
          replacePath: mode,
        });
        if (!isEditPermission) {
          showNotEditableLePlanToast();
        }
      }
    }
    if (isCommunity) trackEntityPreview();
  };

  componentDidUpdate = prevProps => {
    const { updateShowPremiumBanner, assessmentDetails } = this.props;

    updateShowPremiumBanner(
      _.get(assessmentDetails, "showLibraryPremiumBannerForUser", false)
    );

    const prevTotal = _.get(
      prevProps.assessmentDetails,
      "comments.totalCount",
      0
    );
    const prevUnread = _.get(
      prevProps.assessmentDetails,
      "comments.unreadCount",
      0
    );
    const total = _.get(assessmentDetails, "comments.totalCount", 0);
    const unread = _.get(assessmentDetails, "comments.unreadCount", 0);
    if (prevTotal !== total || prevUnread !== unread) {
      this.notifyCommentCounts();
    }
  };

  componentWillUnmount = () => {
    const {
      updateShowPremiumBanner,
      mode,
      setGlobalTrayEnabledState,
      showIntercom,
      sourceFrom,
      updateAssessmentInRedux,
      updateAIDataInRedux,
      assignmentId,
    } = this.props;
    updateShowPremiumBanner(false);
    if (assignmentId) {
      updateAssessmentInRedux({ initialAssessmentToolTypes: [] });
    }

    if (
      sourceFrom !== "CALENDAR" &&
      (mode !== "edit" || _.includes(window.location.href, "classroom"))
    ) {
      setGlobalTrayEnabledState(true); // For showing the tray on Component Unmounted.
      showIntercom();
    }

    updateAIDataInRedux({
      shouldGeneratePreviewChat: false,
      updatedFields: [],
      aiTutorPreviewChatSelectedTabs: {},
      showAITutorStudentPreviewModal: false,
      isAITutorUpdated: false,
    });
  };

  onClose = ({ onlyExit = false }) => {
    const { mode, onCloseCallback, onClose } = this.props;

    if (mode == "create" && onlyExit) {
      this.setState({ showDeleteDialogueBox: true });
    } else {
      onClose({ isRemoved: false });
      if (onCloseCallback) {
        onCloseCallback({ isRemoved: false });
      }
    }
  };

  toggleDeleteDialogueBoxDisplay = () => {
    this.setState({ showDeleteDialogueBox: false });
  };

  onConfirmClose = () => {
    const {
      deleteAssessment,
      onClose,
      onCloseCallback,
      assessmentId,
    } = this.props;
    deleteAssessment({ assessmentId: assessmentId });
    onClose({ isRemoved: true });
    if (onCloseCallback) {
      onCloseCallback({ isRemoved: true });
    }
  };

  onConfirmSave = () => {
    this.step.onClickSave();
  };

  onClickPrint = ({ id, type = "assessment", title } = {}) => {
    const { getPrintFile, assessmentId } = this.props;
    getPrintFile({ id: id || assessmentId, type, extraParams: { title } });
  };

  setStepRef = ref => {
    this.step = ref;
  };

  onCommentClick = () => {
    this.step?.onCommentClick?.();
  };

  notifyCommentCounts = () => {
    const { onCommentCountsChange, assessmentDetails } = this.props;
    onCommentCountsChange?.({
      totalCommentCount: _.get(assessmentDetails, "comments.totalCount", 0),
      unreadCommentCount: _.get(assessmentDetails, "comments.unreadCount", 0),
    });
  };

  getContextValue = () => {
    const {
      courseSubjects,
      creationMode,
      assessmentDetails,
      isFromUnitPlan,
      selectedCourseId,
      subjects,
      isDraft,
      assignmentId,
      onWorksheetDoneClick,
      defaultQuestionIds,
      selectedCourse,
      courseGrades,
      setAssessmentDetailsRef,
      setWorksheetRef,
      prompts,
      gradeScales,
    } = this.props;

    return {
      currentSubject: !_.isEmpty(subjects) ? subjects : courseSubjects,
      selectedCourseId,
      creationMode,
      isFromUnitPlan,
      isDraft,
      assignmentId,
      courseSubjects,
      onWorksheetDoneClick,
      defaultQuestionIds,
      selectedCourse,
      courseGrades,
      setAssessmentDetailsRef,
      setWorksheetRef,
      prompts,
      gradeScales,
      ...assessmentDetails,
    };
  };

  render() {
    const {
      assessmentId,
      unitPlanId,
      template,
      unitPlanTemplate,
      benchmarkSet,
      unitPlanFields,
      assessmentFields,
      assessmentDetails,
      title,
      updateAssessmentInCache,
      grades,
      subjects,
      isData,
      isLoading,
      onClickEdit,
      mode,
      t,
      renderAsComponent,
      sourceFrom,
      portalType,
      location,
      curriculumProgram,
      curriculumType,
      unitPlanName,
      assessmentType,
      taskTypeGroup,
      plannerElements,
      assessmentMode,
      helpEnabledFields,
      selectedCourseId,
      isFromUnitPlan,
      isUnitPlanTemplateLoading,
      unitType,
      isAssessmentLoading,
      courseSubjects,
      subscribeToddleLibraryEvents,
      unSubscribeToddleLibraryEvents,
      creationMode,
      testId = "assessmentDetails",
      ltiDropDownOptions = [],
      isFromInitializingModal = false,
      learningCourseId,
      coursePrimaryGradeId,
      gradeScales,
      unitCourseId,
      handleIsGeneratingAIResponse,
    } = this.props;

    const { showDeleteDialogueBox } = this.state;
    const warningMsg =
      unitPlanName && assessmentType
        ? t(
            "classRoom:changes_made_here",
            getWarningMsgParams(assessmentType, t)
          )
        : "";

    const value = this.getContextValue();

    const dsVersion =
      assessmentType === "worksheet" || taskTypeGroup === TASK_TYPE_WORKSHEET
        ? "1.0"
        : "2.0";

    return (
      !assessmentDetails.isDeleted && (
        <div className={classes.container}>
          <DSProvider dsVersion={dsVersion}>
            {mode != "view" ? (
              <ResourceDetailsContext.Provider value={value}>
                <ResourceEdit
                  unitPlanId={unitPlanId}
                  template={template}
                  helpEnabledFields={helpEnabledFields}
                  templateId={_.get(assessmentDetails, "templateId")}
                  updateFieldInCache={updateAssessmentInCache}
                  unitPlanTemplate={unitPlanTemplate}
                  benchmarkSet={benchmarkSet}
                  unitPlanFields={unitPlanFields}
                  customRef={this.setStepRef}
                  mode={mode}
                  assessmentMode={assessmentMode}
                  isData={isData}
                  isLoading={isLoading}
                  title={title}
                  parentType={"ASSESSMENT"}
                  resourceId={assessmentId}
                  onClose={this.onClose}
                  subjects={subjects}
                  grades={grades}
                  assessmentTools={_.get(
                    assessmentDetails,
                    "assessmentTools",
                    []
                  )}
                  totalCommentCount={_.get(
                    assessmentDetails,
                    "comments.totalCount",
                    0
                  )}
                  unreadCommentCount={_.get(
                    assessmentDetails,
                    "comments.unreadCount",
                    0
                  )}
                  resourceFields={assessmentFields}
                  onClickPrint={this.onClickPrint}
                  renderAsComponent={renderAsComponent}
                  sourceFrom={sourceFrom}
                  portalType={portalType}
                  curriculumProgram={curriculumProgram}
                  curriculumType={curriculumType}
                  warningMsg={warningMsg}
                  assessmentType={assessmentType}
                  taskTypeGroup={taskTypeGroup}
                  plannerElements={plannerElements}
                  assessmentId={assessmentId}
                  selectedCourseId={selectedCourseId}
                  isUnitPlanTemplateLoading={isUnitPlanTemplateLoading}
                  isFromUnitPlan={isFromUnitPlan}
                  unitType={unitType}
                  courseSubjects={courseSubjects}
                  creationMode={creationMode}
                  testId={testId + "Edit"}
                  ltiDropDownOptions={ltiDropDownOptions}
                  location={location}
                  isFromInitializingModal={isFromInitializingModal}
                  learningCourseId={learningCourseId}
                  initialAiPrompt={_.get(
                    assessmentDetails,
                    "metaData.aiPrompt",
                    ""
                  )}
                  coursePrimaryGradeId={coursePrimaryGradeId}
                  handleIsGeneratingAIResponse={handleIsGeneratingAIResponse}
                  onCommentActiveChange={this.props.onCommentActiveChange}
                />
              </ResourceDetailsContext.Provider>
            ) : (
              <ResourceView
                t={t}
                onClickPrint={this.onClickPrint}
                parentType={"ASSESSMENT"}
                isData={isData}
                isLoading={isLoading}
                updateFieldInCache={updateAssessmentInCache}
                onClickEdit={onClickEdit}
                resourceId={assessmentId}
                unitPlanFields={unitPlanFields}
                benchmarkSet={benchmarkSet}
                template={template}
                resourceDetails={assessmentDetails}
                resourceFields={assessmentFields}
                onClose={this.onClose}
                unitPlanId={unitPlanId}
                location={location}
                curriculumProgram={curriculumProgram}
                curriculumType={curriculumType}
                assessmentTools={_.get(
                  assessmentDetails,
                  "assessmentTools",
                  []
                )}
                assessmentType={assessmentType}
                taskTypeGroup={taskTypeGroup}
                assessmentId={assessmentId}
                totalCommentCount={_.get(
                  assessmentDetails,
                  "comments.totalCount",
                  0
                )}
                unreadCommentCount={_.get(
                  assessmentDetails,
                  "comments.unreadCount",
                  0
                )}
                plannerElements={plannerElements}
                subjects={subjects}
                isAssessmentLoading={isAssessmentLoading}
                courseSubjects={courseSubjects}
                subscribeToddleLibraryEvents={subscribeToddleLibraryEvents}
                unSubscribeToddleLibraryEvents={unSubscribeToddleLibraryEvents}
                testId={testId + "View"}
                learningCourseId={learningCourseId}
                unitCourseId={unitCourseId}
              />
            )}

            {showDeleteDialogueBox ? (
              <Dialog
                dsVersion={"2.0"}
                isOpen={true}
                variant={"delete-dialog"}
                title={t("discard_changes")}
                message={t("exit_without_save_prompt")}
                buttonOneText={t("save_and_exit")}
                buttonTwoText={t("discard_and_exit")}
                onButtonOneClick={this.onConfirmSave}
                onButtonTwoClick={this.onConfirmClose}
                onClose={this.toggleDeleteDialogueBoxDisplay}
              />
            ) : null}
          </DSProvider>
        </div>
      )
    );
  }
}

const AssessmentDetailsLoader = withLoader(AssessmentDetails);

const AssessmentDetailsContainer = props => {
  const {
    params: { assessmentId } = {},
    renderAsComponent,
    assessmentType,
    taskTypeGroup,
    courseId,
    selectedCourseId,
    t,
    mode,
    isToddleLibrary,
    location,
    curriculumType,
    creationMode,
    testId = "assessmentDetails",
    isAssessmentLoading,
    setIsAssessmentLoading = () => {},
    gradesFromState,
  } = props;

  const isWorksheet =
    assessmentType == "worksheet" || taskTypeGroup === TASK_TYPE_WORKSHEET;

  useEffect(() => {
    // Propagate loading state to parent component to synchronize UI state across components
    setIsAssessmentLoading?.(isAssessmentLoading);
  }, [isAssessmentLoading]);

  if (isWorksheet && !renderAsComponent && mode != "view") {
    const assignmentModalData = getAssignmentModalData({
      t,
      mode: mode,
    });

    const course = getCourseDetailsFromCache({
      id: courseId,
    });

    const customDeleteFunction = ({ prevLeId }) => {
      const { deleteAssessment, onClose } = props;
      if (mode == "create") {
        if (prevLeId) {
          deleteAssessment({ assessmentId: prevLeId });
        } else {
          deleteAssessment({ assessmentId });
        }
      }
      onClose({ isRemoved: true });
    };

    const onClose = () => {
      const { onCloseCallback, onClose } = props;

      onClose({ isRemoved: false });
      if (onCloseCallback) {
        onCloseCallback({ isRemoved: false });
      }

      removeAssessmentFromLocalStorage({
        courseId: courseId || selectedCourseId,
        curriculumType,
        assessmentType: assessmentType,
        creationMode: _.get(assignmentModalData, "creationMode"),
      });
    };

    return (
      <UIModal isOpen isFullScreen>
        <AddAssignment
          sourceAssessmentId={assessmentId}
          {...assignmentModalData}
          onClose={onClose}
          portalType={"PLANNER"}
          showImageTitleInHeader={false}
          clonedAssessmentId={assessmentId}
          isFromUnitPlan={true}
          isWorksheet={isWorksheet}
          courseId={courseId || selectedCourseId}
          course={course}
          updateUnitPlanDataInRedux={false}
          showInModal={true}
          customDeleteFunction={customDeleteFunction}
          testId={testId + _.capitalize(mode)}
          grades={gradesFromState}
          customFooterButton={
            <Button
              size={"medium"}
              variant={"progressive"}
              onClick={onClose}
              testId={`${testId}-footer-saveAndExit`}
            >
              {t("common:save_and_exit")}
            </Button>
          }
        />
      </UIModal>
    );
  }

  const isToddleLibraryUnitView = isUnitPage(location);
  let containerClassName = classes.overlayContainer;

  if (isToddleLibrary) {
    containerClassName = isToddleLibraryUnitView
      ? classes.toddleLibraryOverlayContainer
      : classes.container;
  } else if (renderAsComponent) {
    containerClassName = classes.container;
  }

  return (
    <div className={containerClassName}>
      <AssessmentDetailsLoader {...props} key={assessmentId} />
    </div>
  );
};

const setPusherData = ({ assessmentId, organizationId, userId }) => {
  return {
    assessmentId,
    organizationId,
    userId,
  };
};

const setPusherDataMemoize = _.memoize(
  params => setPusherData(params),
  ({ assessmentId }) => `${assessmentId}`
);

const mapActionCreators = {
  updateAssessmentInRedux,
  updateAIDataInRedux,
  updateUnitPlanInRedux,
  deleteAssessment,
  getPrintFile,
  updateAssessmentInCache,
  clearAssessmentTool,
  setToastMsg,
  onClose,
  onClickEdit,
  getPlannerFieldsOfNode,
  isUnitPlanEditPermission,
  goToRelativeRoute,
  showNotEditableLePlanToast,
  showWorksheetNotEditableToast,
  trackEntityPreview,
  addApiEvent,
  setCurrentPageTitle,
  updateShowPremiumBanner,
  updateViewCountForToddleLibrary,
  setGlobalTrayEnabledState,
  hideIntercom,
  showIntercom,
  getCurrentAssessmentTypes,
};

const mapStateToProps = (state, ownProps) => {
  const { t, creationMode, libraryBannerFilters } = ownProps;

  const userInfo = getUserInfo({ portalType: ownProps.portalType }) || {};
  const activeTab = state.login.activeTab;
  const isToddleLibrary = activeTab == TODDLE_LIBRARY;

  let learningCourseId =
    _.get(state, "planner.unitPlanData.learningCourseId", null) ||
    getSelectedLearningCourseId(state) ||
    _.get(ownProps, "learningCourseId");

  if (isToddleLibrary && getIsLearningCoursesEnabled()) {
    learningCourseId =
      _.get(state, "classRoom.selectedCourseId", null) || learningCourseId;
  }

  const curriculumType = isToddleLibrary
    ? _.get(state, "classRoom.curriculumProgram.type", "")
    : _.get(state, "platform.currentCurriculumProgram.type", "");

  const curriculumId = isToddleLibrary
    ? _.get(state, "classRoom.curriculumProgram.id", "")
    : _.get(state, "platform.currentCurriculumProgram.id", "");

  let curriculum = null;

  if (curriculumId) {
    curriculum = _.find(state.platform.organizationCurriculumPrograms, {
      id: curriculumId,
    });
  } else {
    curriculum = _.find(state.platform.organizationCurriculumPrograms, {
      type: curriculumType,
    });
  }

  const organizationId = userInfo.org_id;
  const assessmentId =
    ownProps.assessmentId || _.get(ownProps, "params.assessmentId");

  const userId = userInfo.id;

  const isCommunity = activeTab == "community";

  const plannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    []
  );
  const userType = userInfo.user_type;
  const courseId = _.get(state, "teacher.selected_class.selected_course", "");

  const pageTitleInfo = _.get(state, "login.currentPageTitle");

  const mode = ownProps.mode || _.get(ownProps, "params.mode");

  const academicYearId = getSelectedAcademicYearId(state);
  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  const shouldEnableNewArchitecture = ACLStore.can(
    "FeatureFlag:EnableNewLTIArchitecture"
  );

  const isCourseBasedGrading = getIsCourseBasedGradingEnabled();

  const isUsingNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    curriculumProgramId: curriculumId,
    academicYearId: academicYearId,
  });

  const gradesFromState = getGradesFromState(state);

  return {
    academicYearId,
    plannerElementSets,
    curriculumType,
    isCommunity,
    isToddleLibrary,
    isData: true,
    isLoading: false,
    organizationId: userInfo.org_id,
    mode,
    assessmentId,
    gradesFromState,
    pusherData: setPusherDataMemoize({
      assessmentId,
      organizationId,
      userId,
    }),
    userType,
    libraryBannerFilters,
    isAccessCheckSkipped: isCommunity,
    accessPermissions:
      mode === "view"
        ? ACCESS_PERMISSIONS_WITH_FAMILY_ACCESS
        : ACCESS_PERMISSIONS,
    errorText: t("common:sorry_you_dont_have_access_to_this_page"),
    plannerElementTypes: PLANNER_ELEMENT_TYPES_MAPPING[curriculumType],
    curriculumNodeInterfaceType: _.get(curriculum, "nodeInterfaceType", ""),
    curriculumId: _.get(curriculum, "id", ""),
    pageTitleInfo,
    creationMode,
    unitPlanTemplateIdInRedux: _.get(
      state,
      "assessment.assessmentData.unitPlanTemplateId"
    ),
    isUnitPlanTemplateLoading: false,
    courseId,
    curriculumProgramType: curriculumType,
    collaboratorsFilter,
    isLTIToolEnabled:
      getIsEnabledLTITools() || getIsEnableLTIInSubmissionTemplate(),
    learningCourseId,
    isLearningCoursesEnabled: getIsLearningCoursesEnabled(state),
    isAIEvaluationExpanded: _.get(state, "assessment.isAIEvaluationExpanded"),
    shouldEnableNewArchitecture,
    isUsingNewGradingSetupInCourses,
    isCourseBasedGrading,
  };
};

const memoizedGetHelpEnabledFields = _.memoize(
  params => _.keyBy(params, "uid"),
  params => _.join(_.map(params, "uid"), ":")
);

const BLANK_OBJECT = {};
const BLANK_ARRAY = [];

const AssessmentDetailsWithQuery = compose(
  I18nHOC({ resource: ["common", "unitPlanTemplate"] }),
  withRouter,
  connect(mapStateToProps, mapActionCreators),
  graphql(getUnitPlanDetailsQuery, {
    name: "getUnitPlanDetails",
    skip: ({ unitPlanId }) => !unitPlanId,
    options: ({ unitPlanId, collaboratorsFilter }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: unitPlanId,
        assessmentLibraryFilters: { groupType: "ASSESSMENT" },
        leLibraryFilters: { groupType: "LEARNING_ENGAGEMENT" },
        collaboratorsFilter,
      },
    }),
    props({ getUnitPlanDetails, ownProps: { unitPlanId } }) {
      const unitDetails = _.get(getUnitPlanDetails, "node", {});
      const unitPlanName = _.get(unitDetails, "title.value", "");
      return {
        unitPlanName,
        isData: !_.isEmpty(unitDetails),
        networkStatus: getUnitPlanDetails.networkStatus,
        isLoading:
          getUnitPlanDetails["networkStatus"] == 1 ||
          getUnitPlanDetails["networkStatus"] == 2,
      };
    },
  }),
  graphql(getAssessmentQuery, {
    name: "getAssessment",
    options: ({
      assessmentId,
      collaboratorsFilter,
      libraryBannerFilters,
      portalType,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: assessmentId,
        collaboratorsFilter,
        libraryBannerFilters,
        portalType,
      },
    }),
    props({
      getAssessment,
      ownProps: { isData, isLoading, mode, assignmentId },
    }) {
      const assessmentDetails = _.get(getAssessment, "node", BLANK_OBJECT);

      const templateId = _.get(assessmentDetails, "templateId", null);

      // We are extracting the course id to pass it in view section of LE in school library, it is required to launch lti if a user has attach lti to it.

      const unitCourseId = _.get(
        assessmentDetails,
        "unitPlan.courses.[0].id",
        ""
      );

      const {
        unitPlanId,
        grades,
        unitPlanFields,
        unitPlanTemplateId,
      } = getUnitDetailsFromUnitPlanField({
        assessmentDetails,
      });

      const assessmentType = _.get(
        assessmentDetails,
        "assessmentType.value",
        ""
      );

      const taskTypeGroup = _.get(assessmentDetails, "taskType.type", "");
      const type = _.get(assessmentDetails, "type", "");

      const subjects = _.get(
        _.find(unitPlanFields, { uid: "subjects" }),
        "resolvedMinimalTree.subjects"
      );

      const unitType = _.get(
        _.find(unitPlanFields, { uid: "unitType" }),
        "value",
        ""
      );

      const curriculumProgram = _.get(
        assessmentDetails,
        "curriculumProgram",
        {}
      );

      const curriculumType = _.get(curriculumProgram, "type", "IB_PYP");

      // to fetch plannerElements (for pedagogical approaches) for DP curriculum
      const isDPLE =
        _.isEqual(curriculumType, CURRICULUM_TYPE_DP) &&
        _.includes(["LEARNING_ENGAGEMENT", "AI_TUTOR"], type);

      const isAssessmentLoading = _.includes(
        [1, 2],
        getAssessment.networkStatus
      );

      const isWorksheetAssessment =
        assessmentType === ASSESSMENT_TYPE_WORKSHEET ||
        taskTypeGroup === TASK_TYPE_WORKSHEET;

      const assessmentFields = _.get(
        assessmentDetails,
        "allFields",
        BLANK_ARRAY
      );

      const assessmentSubjectIds =
        _.find(assessmentFields, { uid: "subjects" })?.value || [];

      return {
        onPusherEventTriggered: params => {
          if (assignmentId && mode === "edit") {
            getAssessmentQuery.refetch();
          }
        },
        curriculumProgram,
        curriculumType,
        unitPlanFields,
        assessmentDetails,
        subjects,
        unitPlanTemplateId,
        unitPlanId,
        grades,
        templateId,
        assessmentType,
        taskTypeGroup,
        assessmentFields,
        isData: !_.isEmpty(assessmentDetails) && isData,
        isLoading: isAssessmentLoading || isLoading,
        isAssessmentLoading,
        unitType,
        type,
        isDPLE,
        isWorksheetAssessment,
        assessmentSubjectIds,
        unitCourseId,
      };
    },
  }),
  graphql(getPlannerTemplateQuery, {
    name: "getPlannerTemplate",
    skip: ({ unitPlanTemplateId, mode }) =>
      mode === "view" || !unitPlanTemplateId,
    options: ({ unitPlanTemplateId, i18n }) => ({
      fetchPolicy: "cache-and-network",
      variables: getVariablesForLocalisedPlannerTemplates({
        templates: [unitPlanTemplateId],
        language: i18n.language,
      }),
    }),
    props({ getPlannerTemplate, ownProps: { isLoading, isData } }) {
      const template = getPlannerTemplateFromCache(
        getPlannerTemplate.variables
      );

      return {
        isData: !_.isEmpty(template) && isData,
        isLoading:
          getPlannerTemplate["networkStatus"] == 1 ||
          getPlannerTemplate["networkStatus"] == 2 ||
          isLoading,
        unitPlanTemplate: _.get(template, "body", {}),
      };
    },
  }),
  graphql(getLTIServicesForCurriculumQuery, {
    name: "getLTIServicesForCurriculum",
    options: ({ curriculumId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        input: {
          entityId: [curriculumId],
          entityType: ["CURRICULUM_PROGRAM"],
          credType: ["LTI_CONFIG"],
          context: "ASSIGNMENT",
          isEnabledForUse: true,
        },
      },
    }),
    skip: ({ mode, isLTIToolEnabled, type, curriculumId }) => {
      return (
        mode === "view" ||
        !isLTIToolEnabled ||
        !_.includes(
          [LEARNING_ENGAGEMENT, ASSESSMENT, ASSESSMENT_TYPE_QUICK_TASK],
          type
        ) ||
        _.isEmpty(curriculumId)
      );
    },
    props: ({
      getLTIServicesForCurriculum,
      ownProps: { isData, isLoading, shouldEnableNewArchitecture },
    }) => {
      const ltiServicesForCurriculum = _.get(
        getLTIServicesForCurriculum,
        ["integration", "getLTIIntegrationsCreds"],
        []
      );

      const filteredLTIServices = shouldEnableNewArchitecture
        ? ltiServicesForCurriculum
        : ltiServicesForCurriculum.filter(service => {
            const serviceDetails = LTI_SERVICE_DETAILS[service.serviceName];
            // Keep services that only:
            // - exist and have placement === "ASSIGNMENT"
            return serviceDetails?.placement === LTI_PLACEMENT.ASSIGNMENT;
          });

      const ltiServices = _.map(filteredLTIServices, item =>
        item.serviceName === "CUSTOM"
          ? { label: item.name, type: item.serviceName }
          : { label: item.serviceName, type: item.serviceName }
      );

      const ltiDropDownOptions = _.map(ltiServices, ({ label, type }) => {
        return {
          key: `add_lti_resource_${label}`,
          label: type === "CUSTOM" ? label : getLTIName(label) || label,
        };
      });

      return {
        ltiDropDownOptions,
        isData: isData && !_.isEmpty(getLTIServicesForCurriculum),
        isLoading:
          isLoading ||
          _.includes([1, 2], getLTIServicesForCurriculum["networkStatus"]),
      };
    },
  }),
  graphql(getAssessmentCourseDetailsQuery, {
    name: "getAssessmentCourseDetails",
    skip: ({ selectedCourseId, courseId, isLearningCoursesEnabled }) =>
      isLearningCoursesEnabled ||
      (_.isEmpty(selectedCourseId) && _.isEmpty(courseId)),
    options: ({ selectedCourseId, courseId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: selectedCourseId || courseId,
        portalType: "PLANNER",
      },
    }),
    props: ({
      getAssessmentCourseDetails: { node, networkStatus },
      ownProps: { isData, isLoading },
    }) => {
      const coursePrimaryGradeId = _.get(node, "primaryGrade.id", null);

      return {
        coursePrimaryGradeId,
        isData: isData && !_.isEmpty(node),
        isLoading: isLoading || _.includes([1, 2], networkStatus),
      };
    },
  }),
  graphql(getAssessmentLearningCourseDetailsQuery, {
    name: "getAssessmentLearningCourseDetails",
    skip: ({ learningCourseId, isLearningCoursesEnabled }) =>
      !isLearningCoursesEnabled || _.isEmpty(learningCourseId),
    options: ({ learningCourseId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: learningCourseId,
        portalType: "PLANNER",
      },
    }),
    props: ({
      getAssessmentLearningCourseDetails: { node, networkStatus },
      ownProps: { isData, isLoading, isToddleLibrary },
    }) => {
      const coursePrimaryGradeId = _.get(node, "primaryGrade.id", null);

      return {
        coursePrimaryGradeId,
        isData: isData && (!_.isEmpty(node) || isToddleLibrary),
        isLoading:
          isLoading || (_.includes([1, 2], networkStatus) && !isToddleLibrary),
      };
    },
  }),
  graphql(getCourseGradingConfigQuery, {
    name: "getCourseGradingConfig",
    skip: ({
      learningCourseId,
      isLearningCoursesEnabled,
      isUsingNewGradingSetupInCourses,
      isCourseBasedGrading,
    }) =>
      !isLearningCoursesEnabled ||
      !learningCourseId ||
      !isUsingNewGradingSetupInCourses ||
      !isCourseBasedGrading,
    options: ({ curriculumType, learningCourseId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: learningCourseId,
        filters: {
          type: getGradingConfigTypesFilter(curriculumType),
        },
      },
    }),
  }),
  graphql(getMultiSubjectsGradingConfigQuery, {
    name: "getMultiSubjectsGradingConfig",
    skip: ({
      assessmentSubjectIds,
      coursePrimaryGradeId,
      isUsingNewGradingSetupInCourses,
      isCourseBasedGrading,
    }) =>
      !isUsingNewGradingSetupInCourses ||
      isCourseBasedGrading ||
      _.isEmpty(assessmentSubjectIds) ||
      _.isEmpty(coursePrimaryGradeId),
    options: ({
      curriculumType,
      assessmentSubjectIds,
      coursePrimaryGradeId,
      academicYearId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: assessmentSubjectIds,
        filters: {
          gradeIds: [coursePrimaryGradeId],
          type: getGradingConfigTypesFilter(curriculumType),
          academicYearId,
        },
        gradingMethodologyFilters: {
          gradeIds: [coursePrimaryGradeId],
          academicYearId,
        },
        portalType: "PLANNER", //To send planner jwt in library
      },
    }),
  }),
  graphql(getMYPIBDefinedGradeScalesQuery, {
    name: "getGradeScaleDetails",
    skip: ({ curriculumType, isUsingNewGradingSetupInCourses }) =>
      curriculumType !== CURRICULUM_TYPE_MYP ||
      !isUsingNewGradingSetupInCourses,
    options: ({ curriculumProgramId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: curriculumProgramId,
        filters: {
          isArchived: false,
          types: MYP_IB_DEFINED,
          entityType: "CURRICULUM_PROGRAM",
          entityDetailFilters: [
            {
              curriculumProgramId,
            },
          ],
        },
        gradeScaleEntityDetailsFilters: {
          entityType: "CURRICULUM_PROGRAM",
          entityDetails: [
            {
              curriculumProgramId,
            },
          ],
        },
      },
    }),
  }),
  graphql(getPlannerTemplateQuery, {
    name: "getPlannerTemplate",
    skip: ({ templateId }) => !templateId,
    options: ({ templateId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        portalType,
        ids: [templateId],
      },
    }),
    props({
      getPlannerTemplate,
      ownProps: {
        templateId,
        isLoading,
        isData,
        mode,
        unitType,
        subjects,
        plannerElementSets,
        curriculumType,
        t,
        organizationId,
        courseSubjects,
        creationMode,
        unitPlanFields,
        unitPlanTemplate,
        curriculumId,
        assessmentType,
        taskTypeGroup,
        ltiDropDownOptions,
        isFromInitializingModal,
        isWorksheetAssessment,
        assessmentFields,
        isAIEvaluationExpanded,
        isUsingNewGradingSetupInCourses,
        learningCourseId,
        assessmentSubjectIds,
        coursePrimaryGradeId,
        courseId,
        academicYearId,
      },
    }) {
      const templates = getPlannerTemplateFromCache(
        getPlannerTemplate.variables,
        true
      );

      const template = _.find(templates, { id: templateId });
      let templateBody = _.get(template, "body", {});
      const helpEnabledFields = _.get(template, "helpEnabledFields", {});

      const isWorksheetCreateOrEditMode =
        (_.isEqual(assessmentType, ASSESSMENT_TYPE_WORKSHEET) ||
          taskTypeGroup === TASK_TYPE_WORKSHEET) &&
        _.includes(["create", "edit"], mode);

      const showTaskWeightageV3 =
        (_.isEqual(assessmentType, ASSESSMENT_TYPE_WORKSHEET) ||
          taskTypeGroup === TASK_TYPE_WORKSHEET) &&
        _.includes(["create", "edit"], mode);

      if (!_.isEmpty(templateBody) && isWorksheetCreateOrEditMode) {
        templateBody = removeFieldsFromTemplate(templateBody);
      }

      const isAIEvaluationEnabled = _.get(
        _.find(assessmentFields, { uid: "aiEvaluation" }),
        "value",
        false
      );

      const isCustomWeightsV2 =
        isUsingNewGradingSetupInCourses &&
        checkAssignmentContributionMethodValue({
          curriculumProgramType: curriculumType,
          learningCourseId,
          subjectIds: assessmentSubjectIds,
          primaryGradeId: coursePrimaryGradeId,
          academicYearId,
        });

      const shouldRemoveCoverImage =
        isWorksheetAssessment && !isWorksheetCreateOrEditMode;

      return {
        template: getDynamicTemplate({
          template: templateBody,
          unitType,
          t,
          plannerElementSets,
          curriculumType,
          unitPlanTemplate,
          organizationId,
          subjects,
          mode,
          courseSubjects,
          creationMode,
          curriculumId,
          templateId,
          ltiDropDownOptions,
          isFromInitializingModal,
          shouldRemoveCoverImage,
          isAIEvaluationEnabled,
          isAIEvaluationExpanded,
          showTaskWeightageV3,
          isCustomWeightsV2,
          isUsingNewGradingSetupInCourses,
          learningCourseId,
          courseId,
        }),
        unitPlanFields: combineUnitPlanMultiFieldData({
          templateBody,
          unitPlanFields: _.cloneDeep(unitPlanFields),
        }),
        helpEnabledFields: memoizedGetHelpEnabledFields(helpEnabledFields),
        isData: !_.isEmpty(templates) && isData,
        isLoading:
          getPlannerTemplate["networkStatus"] == 1 ||
          getPlannerTemplate["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getPlannerTemplateQuery, {
    name: "getPlannerTemplate",
    skip: ({ unitPlanTemplateIdInRedux }) =>
      _.isEmpty(unitPlanTemplateIdInRedux),
    options: ({ unitPlanTemplateIdInRedux, i18n }) => ({
      fetchPolicy: "cache-and-network",
      variables: getVariablesForLocalisedPlannerTemplates({
        templates: [unitPlanTemplateIdInRedux],
        language: i18n.language,
      }),
    }),
    props: ({ getPlannerTemplate: { networkStatus, variables } }) => {
      const unitPlanTemplate = getPlannerTemplateFromCache(variables);
      return {
        unitPlanTemplate: _.get(unitPlanTemplate, "body", {}),
        isUnitPlanTemplateLoading: _.includes([1, 2], networkStatus),
      };
    },
  }),
  graphql(getAIPromptsBasicDetailsQuery, {
    name: "getAIPromptsBasicDetails",
    skip: ({ assessmentId, assessmentType, taskTypeGroup, organizationId }) =>
      !assessmentId ||
      (assessmentType !== "ai_tutor" && taskTypeGroup !== TASK_TYPE_AI_TUTOR) ||
      organizationId != resourceLibrarySourceOrg?.aiTutor,
    options: ({ assessmentId, curriculumId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        filters: {
          entityId: assessmentId,
          entityType: "ai_tutor",
          curriculumProgramId: curriculumId,
        },
        portalType,
      },
    }),
    props: ({
      getAIPromptsBasicDetails: { networkStatus, ai },
      ownProps: { isData, isLoading },
    }) => {
      const prompts = _.get(ai, "prompts", []);

      return {
        prompts,
        isData: isData && !_.isEmpty(ai),
        isLoading: isLoading || _.includes([1, 2], networkStatus),
      };
    },
  }),

  getPlannerElementSetsOfCurriculumEnhancer,
  getGradeScalesQueryEnhancer,
  WithConfigurationsAndPreferences({
    skip: ({ organizationId, curriculumId }) =>
      !organizationId || !curriculumId,
    options: ({ organizationId, curriculumId }) => {
      return {
        variables: generateConfigurationQueryVariablesV2({
          organizationId,
          src: "ORG_CURRICULUM_LEVEL",
          currentCurriculumProgramId: curriculumId,
          modules: ["ASSIGNMENT_EDIT"],
        }),
      };
    },
    getConfigurationKeys: () => ["ORGANIZATION", "CURRICULUM"],
  }),
  withCombinedAccessBlocker,
  withPusherSubscribe(["assessment"]),
  withPresenceChannel("assessment"),
  withPusherBind(["submissionTemplateUpdate"])
)(AssessmentDetailsContainer);

/***********************************************************************************************************************
 *                                                                                                                     *
 *                                                Custom loader HOC                                                    *
 *                                                                                                                     *
 ***********************************************************************************************************************/

const LoaderHOC = WrappedComponent => {
  const WrappedComponentWithLoader = props => {
    const {
      isData,
      isLoading,
      isSettingsStepOnly,
      isLearningCoursesEnabled,
      isCourseOrUnitFlowRoute,
      isCreationInPlanner,
    } = props;

    if (
      !isData &&
      isLoading &&
      (isLearningCoursesEnabled || isCreationInPlanner) &&
      isCourseOrUnitFlowRoute
    ) {
      if (isSettingsStepOnly) {
        return <FullScreenLoader />;
      }

      return (
        <UIModal isOpen isFullScreen>
          <div className={classes.loadingContainer}>
            <Loading />
          </div>
        </UIModal>
      );
    }

    return <WrappedComponent {...props} />;
  };

  return WrappedComponentWithLoader;
};

/***********************************************************************************************************************
 *                                                                                                                     *
 *                                                New wrapper component starts here                                    *
 *                                                                                                                     *
 ***********************************************************************************************************************/

/**
 * This is a wrapper component for AssessmentDetails created to handle Assessment/Assignment create/edit flow from course/unit flow in new Course setup.

 * Why need this wrapper here ?
 * 1. When user clicks on create/edit assessment from course/unit flow, we are opening assessment create/edit routes (assessments/:assessmentId/:mode).
 * 2. In assessment create/edit route, we are rendering AssessmentDetails component which alone does not support assign flow directly.
 * 3. However when trying to create/edit assessment from course/unit flow, we need to give Assign and Save as draft functionality just like AddAssignment component.
 * 4. So, here we are checking if user is trying to create/edit assessment from course/unit flow, then we are rendering AddAssignment component instead of directly rendering AssessmentDetails component.
 * 5. This way we are able to support assessment create/edit with full Assign flow functionality in a non hacky way.

 * This will only work for new Course setup. For old setup we will directly render AssessmentDetails component only.
 * All the logic related to assign flow will be handled in AddAssignment component only.
 */
const AssessmentDetailsWrapper = props => {
  const {
    skipAddAssignmentRender,
    isLearningCoursesEnabled,
    assessmentDetails,
    getCurrentAssessmentTypes,
    ubdAssessmentTypes,
    curriculumProgramType,
    assessmentId,
    onClose,
    assessmentMode,
    isSettingsStepOnly,
    onCloseSettings,
    goToRelativeRoute,
    learningCourseId,
    curriculumProgramId,
    isCourseOrUnitFlowRoute,
    isTimetablePlanner,
    isCourseFlowRoute,
    isUnitFlowRoute,
    isClassPlannerRoute,
    isUnitRoute,
    primaryGradeId,
    shouldOpenSubmissions,
    isCreationInPlanner,
    grades,
    courseId,
  } = props;

  const { t } = useI18n();

  const type = _.get(assessmentDetails, "type", "");
  const assessmentType = _.get(assessmentDetails, "assessmentType.value", "");
  const linkedAssignments = _.get(assessmentDetails, "assignments.edges", []);
  const userAssignments = _.get(
    assessmentDetails,
    "assignments.userAssignmentEdges",
    []
  );
  const assignmentState = _.get(_.first(linkedAssignments), "state.state");
  const isLocked = getIsItemLocked({ item: assessmentDetails });
  const hasConflict = getHasConflict({ item: assessmentDetails });
  const syncStatus = _.get(
    assessmentDetails,
    "isSyncedWithAllTeacherCourseV2",
    null
  );

  const isAssessmentLocked =
    isLocked &&
    _.get(assessmentDetails, "learningCourse.type", null) !==
      "BLUEPRINT_COURSE";

  const learningCourseContexts = generateRnPContextsByLevel({
    level: "LEARNING_COURSE",
    learningCourseId,
    curriculumProgramId,
    gradeId: primaryGradeId,
  });

  const isManageCourseFlowPermission =
    isLearningCoursesEnabled &&
    ACLStorage.getPermissionValueByContext(
      CAN_EDIT_COURSE_FLOW_PERMISSION,
      _.first(learningCourseContexts)
    );

  const isTeacherCourseAssociationEnabled = isBluePrintTeacherCourseSyncEnabled();

  const showAssessmentLockIcon =
    isLearningCoursesEnabled &&
    isTeacherCourseAssociationEnabled &&
    _.get(assessmentDetails, "learningCourse.type", null) ===
      "BLUEPRINT_COURSE" &&
    isManageCourseFlowPermission;

  const goToClassRoomDetailsRoute = assignmentId => {
    goToRelativeRoute({
      route: `../../../classroom-details/${assignmentId}/allSubmissions`,
      type: "replace",
    });
  };

  const goToAssessmentEditRoute = () => {
    goToRelativeRoute({
      route: "../edit",
      type: "replace",
    });
  };

  const isShared = !_.isEmpty(userAssignments) && assignmentState !== "DRAFT";

  useEffect(() => {
    if (
      isLearningCoursesEnabled &&
      ((assessmentMode === "view" && isUnitRoute && !isUnitFlowRoute) ||
        shouldOpenSubmissions)
    ) {
      if (isShared) {
        goToClassRoomDetailsRoute(_.first(userAssignments)?.id);
      } else {
        const academicTerm = _.get(assessmentDetails, "academicTerm", {});
        const isGradingPeriodUnlocked = getIsGradingPeriodUnlocked(
          academicTerm,
          assessmentType
        );
        if (
          isGradingPeriodUnlocked &&
          isManageCourseFlowPermission &&
          !isAssessmentLocked
        ) {
          goToAssessmentEditRoute();
        }
      }
    }
  }, [assessmentDetails]);

  /**
   * Why skipAddAssignmentRender prop ?
   * 1. Here AssessmentDetailsWrapper is rendering AddAssignment component. AddAssignment again internally renders AssessmentDetailsWrapper only.
   * 2. So when we are rendering AssessmentDetailsWrapper from AddAssignment, we need to skip rendering AddAssignment again here else it will go in infinite loop.
   * 3. So pass skipAddAssignmentRender prop as true when rendering AssessmentDetailsWrapper from AddAssignment.
   */

  if (
    (!isLearningCoursesEnabled && !isCreationInPlanner) ||
    !isCourseOrUnitFlowRoute ||
    (isTimetablePlanner &&
      !isSettingsStepOnly &&
      assessmentMode !== "create") ||
    skipAddAssignmentRender ||
    (isAssessmentLocked && !isSettingsStepOnly) ||
    (assessmentMode === "view" &&
      (!isShared || isCourseFlowRoute || isUnitFlowRoute))
  ) {
    return <AssessmentDetailsWithQuery {...props} />;
  }

  /**
   * Why need to derive "mode" this way and not just rely on whether user has clicked on create or edit ?
   * 1. This is because there can be case where user has created assessment but not assigned to any class.
   * 2. In this case, when user clicks on edit, we need to open AddAssignment in "create" mode only and not in "edit" mode.
   * 3. So here we are checking if assessment is linked to any class assignment then open AddAssignment in "edit" mode else in "create" mode.
   */
  const mode = _.isEmpty(linkedAssignments) ? "create" : "edit";

  const isAssessmentTypeConfigurationEnabled = ACLStore.can(
    "FeatureFlag:AssessmentTypeConfiguration"
  );

  const isUbDAssessment =
    curriculumProgramType == CURRICULUM_TYPE_UBD && type === ASSESSMENT;

  const assessmentTypeMap = _.get(
    ASSESSMENT_TYPE_UID_CREATE_OPTION_MAPPING,
    assessmentType,
    defaultOption
  );

  const createOptionKey = isUbDAssessment ? defaultOption : assessmentTypeMap;

  const assignmentModalData = getAddAssignmentModalData({
    t,
    key: isAssessmentTypeConfigurationEnabled
      ? assessmentType
      : createOptionKey,
    currentAssessmentTypes: getCurrentAssessmentTypes(),
    ubdAssessmentTypes,
    mode,
    assessmentDetails,
    isSettingsStepOnly,
    grades,
  });

  const transparentModalClass = isSettingsStepOnly
    ? classes.transparentModal
    : "";

  return !_.isEmpty(assignmentModalData) ? (
    <UIModal
      isOpen
      isFullScreen
      modalContent={transparentModalClass}
      overlayContainer={transparentModalClass}
    >
      <AddAssignment
        {...assignmentModalData}
        mode={mode}
        courseId={courseId}
        sourceAssessmentId={assessmentId}
        clonedAssessmentId={assessmentId}
        creationSource={isClassPlannerRoute ? "CLASS_PLANNER" : "COURSE_FLOW"}
        onClose={isSettingsStepOnly ? onCloseSettings : onClose}
        assignmentId={_.first(linkedAssignments)?.id}
        isSettingsStepOnly={isSettingsStepOnly}
        testId="courseFlow"
        showAssessmentLockIcon={showAssessmentLockIcon}
        isLocked={isLocked}
        hasConflict={hasConflict}
        syncStatus={syncStatus}
        assessmentMode={assessmentMode}
        learningCourseId={learningCourseId}
        isUnitRoute={isUnitRoute}
      />
    </UIModal>
  ) : null;
};

const getDerivedProps = ownProps => {
  const {
    location,
    sourceFrom: _sourceFrom,
    creationSource: _creationSource,
  } = ownProps;

  const assessmentMode =
    _.get(ownProps, "params.mode") || _.get(ownProps, "assessmentMode");

  const isCourseFlowRoute =
    location.pathname.search("course-flow") > -1 ||
    location.pathname.search("course-plan/flow") > -1;
  const isUnitFlowRoute = location.pathname.search("unitFlow") > -1;
  const isClassPlannerRoute =
    location.pathname.search("weekly-planners") > -1 ||
    location.pathname.search("class-planners") > -1;
  const isTimetablePlanner =
    location.pathname.search("timetable") > -1 ||
    location.pathname.search("schedule") > -1;

  const isUnitRoute = Boolean(_.get(ownProps, "params.unit_id", null));

  const shouldOpenSubmissions = _.get(
    location,
    "state.shouldOpenSubmissions",
    false
  );

  let sourceFrom = _sourceFrom;
  if (isClassPlannerRoute) {
    sourceFrom = "CLASS_PLANNER";
  }

  const isLearningCoursesEnabled =
    isUnitFlowRoute || isUnitRoute
      ? getIsLearningCoursesEnabledForUnit()
      : getIsLearningCoursesEnabled();

  const isCreationInPlanner =
    isClassPlannerRoute && assessmentMode === "create";

  return {
    isData: true,
    isLoading: false,
    assessmentId:
      ownProps.assessmentId || _.get(ownProps, "params.assessmentId"),
    isLearningCoursesEnabled,
    assessmentMode:
      _.get(ownProps, "params.mode") || _.get(ownProps, "assessmentMode"),
    isCourseOrUnitFlowRoute:
      isCourseFlowRoute ||
      isUnitFlowRoute ||
      isClassPlannerRoute ||
      isTimetablePlanner ||
      isUnitRoute,
    isTimetablePlanner,
    isClassPlannerRoute,
    isCourseFlowRoute,
    isUnitFlowRoute,
    isUnitRoute,
    sourceFrom,
    isCreationInPlanner,
    shouldOpenSubmissions,
  };
};

const wrappedMapStateToProps = (state, ownProps) => {
  const ubdAssessmentTypes = _.get(state, "platform.ubdAssessmentTypes", {});
  const curriculumProgramType = getCurrentCurriculumProgramType(state);
  const grades = getGradesFromState(state);
  const courseId = getSelectedCourseId(state);

  return {
    curriculumProgramType,
    ubdAssessmentTypes,
    grades,
    courseId,
    learningCourseId:
      _.get(ownProps, "learningCourseId") ||
      _.get(state, "planner.unitPlanData.learningCourseId", null) ||
      getSelectedLearningCourseId(state),
    curriculumProgramId: getSelectedCurriculumId(state),
    primaryGradeId:
      _.get(ownProps, "primaryGradeId") ||
      (getIsLearningCoursesEnabled()
        ? _.get(state, "learningCourse.selectedLearningCourse.primaryGradeId")
        : _.get(state, "teacher.selected_class.primaryGrade.id")),
  };
};

const wrapperMapActionCreators = {
  getCurrentAssessmentTypes,
  onClose,
  goToRelativeRoute,
};

export default compose(
  withRouter,
  connect(wrappedMapStateToProps, wrapperMapActionCreators),
  withDerivedProps(getDerivedProps),
  withControlParameters({
    skip: ({
      isLearningCoursesEnabled,
      skipAddAssignmentRender,
      curriculumProgramId,
      learningCourseId,
      isCourseOrUnitFlowRoute,
    }) =>
      !isLearningCoursesEnabled ||
      !isCourseOrUnitFlowRoute ||
      skipAddAssignmentRender ||
      !curriculumProgramId ||
      !learningCourseId,
    skipContextSetup: true,
    options: ({ curriculumProgramId, learningCourseId, primaryGradeId }) => {
      const learningCourseContexts = generateRnPContextsByLevel({
        level: "LEARNING_COURSE",
        learningCourseId,
        curriculumProgramId,
        gradeId: primaryGradeId,
      });

      return {
        variables: {
          filters: {
            module: "LEARNING_COURSE_FLOW",
            appType: ["TEACHER_WEB"],
            contexts: learningCourseContexts,
          },
        },
      };
    },
  }),
  graphql(getAssessmentLinkedAssignmentsQuery, {
    name: "getAssessmentLinkedAssignments",
    skip: ({
      isLearningCoursesEnabled,
      skipAddAssignmentRender,
      isCourseOrUnitFlowRoute,
      isCreationInPlanner,
    }) =>
      (!isLearningCoursesEnabled && !isCreationInPlanner) ||
      skipAddAssignmentRender ||
      !isCourseOrUnitFlowRoute,
    options: ({ assessmentId }) => ({
      fetchPolicy: "network-only",
      variables: {
        id: assessmentId,
      },
    }),
    props: ({
      getAssessmentLinkedAssignments,
      ownProps: { isData, isLoading, grades: propsGrades },
    }) => {
      const assessmentDetails = _.get(
        getAssessmentLinkedAssignments,
        "node",
        {}
      );
      const queryGrades = _.get(assessmentDetails, "grades");
      // Use GraphQL grades if they are explicitly provided (including empty array),
      // otherwise fall back to Redux grades (or an empty array).
      const finalGrades = !_.isNil(queryGrades)
        ? queryGrades
        : propsGrades || [];

      return {
        assessmentDetails,
        grades: finalGrades,
        isData: !_.isEmpty(assessmentDetails) && isData,
        isLoading:
          _.includes([1, 2], getAssessmentLinkedAssignments?.networkStatus) ||
          isLoading,
      };
    },
  }),
  LoaderHOC
)(AssessmentDetailsWrapper);
